import { render, staticRenderFns } from "./GlobalIntro.vue?vue&type=template&id=d9223a64&"
import script from "./GlobalIntro.vue?vue&type=script&lang=js&"
export * from "./GlobalIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports